// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"578":"css/app.6886","1597":"css/admin-app.6886"}[chunkId] + ".css";
};